import { AFbLink } from 'components/FbUI/FbLink/styles'
import { PiTrash } from 'react-icons/pi'
import styled from 'styled-components'

interface FileContainerProps {
  file: { name: string }
  handleRemoveFile?: () => void
  LeftIcon?: React.ComponentType<{ size: number; color: string }>
  RemoveFileIcon?: React.ComponentType<{
    size: number
    className?: string
  }>
  noOutline?: boolean
  href?: string
}

export default function FileContainer(props: FileContainerProps) {
  const { file, handleRemoveFile, LeftIcon, RemoveFileIcon, noOutline, href } =
    props
  const RemoveIcon = RemoveFileIcon ?? PiTrash

  const FileNameContent = (
    <FileContent leftBorder={!!LeftIcon}>
      {file.name}
      {handleRemoveFile && (
        // DS2026 dismiss affordance: smaller, lighter icon in a button with a
        // rounded neutral hover (the icon inherits the button's text color).
        <button
          type="button"
          aria-label="Remove file"
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            handleRemoveFile()
          }}
          className="flex items-center rounded-md p-1 text-fg-tertiary transition-colors hover:bg-surface-sunken hover:text-fg-secondary"
        >
          <RemoveIcon size={18} />
        </button>
      )}
    </FileContent>
  )

  return (
    <FileMainContainer noOutline={noOutline}>
      {!!LeftIcon && <LeftIcon size={22} color="#449C0A" />}
      {href ? (
        <AFbLink
          href={href}
          target="_blank"
          rel="noreferrer"
          className="flex-1"
        >
          {FileNameContent}
        </AFbLink>
      ) : (
        FileNameContent
      )}
    </FileMainContainer>
  )
}

const FileMainContainer = styled.div<{ noOutline?: boolean }>`
  padding: 0 13px;
  display: flex;
  align-items: center;
  ${({ noOutline }) =>
    !noOutline &&
    `
    border: 1px solid #d3dfe7;
    border-radius: 8px;
    `}
`

const FileContent = styled.div<{ leftBorder?: boolean }>`
  min-height: 32px;
  display: flex;
  justify-content: space-between;
  display: flex;
  align-items: center;
  color: #2e3748;
  font-weight: 500;
  font-size: 14px;
  flex: 1;
  ${({ leftBorder }) =>
    leftBorder &&
    `
    padding-left: 13px;
    margin-left: 13px;
    border-left: 1px solid #d3dfe7;
    `}
`
